import { SharedModule } from '@app/modules/shared/shared.module';
import { PipesModule } from './../../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmationComponent } from './../../components/confirmation/confirmation.component';
import { SummaryComponent } from './../../components/summary/summary.component';
import { CheckoutComponent } from './checkout.component';
import { CheckoutAuthentificationComponent } from './../../components/checkout-authentification/checkout-authentification.component';
import { NgModule } from '@angular/core';
import { PanierModule } from '@app/modules/panier/panier.module';
import { routing } from '@app/modules/checkout/checkout.routing';
import { HelpycurrencyModule } from '@app/pipes/helpycurrency/helpycurrency.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PanierModule,
        routing,
        PipesModule,
        SharedModule,
        HelpycurrencyModule
    ],
    declarations: [
        CheckoutComponent,
        SummaryComponent,
        ConfirmationComponent,
        CheckoutAuthentificationComponent
    ],
    exports: [
        CheckoutComponent,
        SummaryComponent,
        ConfirmationComponent,
        CheckoutAuthentificationComponent,
    ]
})

export class CheckoutModule {

}
